import * as React from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import * as styles from './NavLink.module.scss';
import { isMobileMenuOpen } from '../../redux/menu/selectors';
import { NavLinkProps } from './types';
import Content from './Content';
import useLgBreakpoint from '../../hooks/useLgBreakpoint';

export default function NavLink(link: NavLinkProps) {
    const [open, setOpen] = React.useState(false);
    const ref = React.useRef<HTMLLIElement>(null);
    const mobileMenuOpen = useSelector(isMobileMenuOpen);
    const isSmallScreen = useLgBreakpoint();
    const hasSubItems = !!link.subItems?.length;

    const canToggle = isSmallScreen && hasSubItems;

    const handleToggle = React.useCallback(() => {
        if (canToggle) {
            setOpen((prev) => !prev);
        }
    }, [canToggle]);

    const handleKeyDown = React.useCallback(
        (event: React.KeyboardEvent<HTMLLIElement>) => {
            if (event.key === 'Enter') {
                handleToggle();
            }
        },
        [handleToggle],
    );

    React.useEffect(() => {
        if (open) {
            document.documentElement.classList.add('mobile-sub-menu-open');
        } else {
            document.documentElement.classList.remove('mobile-sub-menu-open');
        }
    }, [open]);

    React.useEffect(() => {
        if (open && !mobileMenuOpen) {
            setOpen(false);
        }
    }, [open, mobileMenuOpen]);

    return (
        <li
            role="menuitem"
            className={classNames({
                [styles.hasSubMenu]: hasSubItems,
                [styles.subMenuOpen]: open,
                [styles.subMenuOpenKey]: link.submenuOpen,
            })}
            onClick={handleToggle}
            onKeyDown={handleKeyDown}
            ref={ref}
        >
            <Content {...link} />
        </li>
    );
}
